 <script>
	import ImageUploadCard from "./ImageUploadCard.svelte";
	import ImagePicker from "./ImagePicker.svelte";
	import { chatAssetFolder } from "./imageAssetApi";
	import { Section, Input, Textarea, Switch } from "../../lib/ui";

	export let chat;
	// 프로필/배경이 이미지 자산으로 통합돼 로컬 업로드 대신 라이브러리에서 고른다 → 더는 안 씀(호환 위해 남김).
	export let onImageFileUpload = undefined;
	export let handleTextareaNextbreak;
	let tab = "info";

	// 프로필/배경도 로고와 같은 이미지 자산 라이브러리(ImagePicker)에서 고른다. AI 생성은 그대로 병행.
	// 저장은 assetId(ref)만. 표시 URL은 서버가 current 버전으로 resolve해 내려준다(교체 시 자동 최신화).
	let profilePickerOpen = false;
	let backPickerOpen = false;
	const onProfilePick = (e) => {
		const { assetId, url } = e.detail || {};
		chat.changeProfileAsset(assetId, url);
		chat = chat;
	};
	const onBackPick = (e) => {
		const { assetId, url } = e.detail || {};
		chat.changeBackAsset(assetId, url);
		chat = chat;
	};

	const onChangeTitle = (e) => {
		chat.changeTitle(e.target.value);
	};

	const toggleBackImageBlur = () => {
		chat.changeBackImageBlur();
	};

	const toggleBackImageDarkly = () => {
		chat.changeBackImageDarkly();
	};

	// V3: 프로필 이미지 표시 토글 (배포 채팅이 __CHAT_CONFIG__.features로 읽음). 블록 채팅(V3) 전용.
	let showProfileImage = chat?.profileChatCss?.showProfileImage !== false;
	const toggleProfileImage = () => {
		showProfileImage = !showProfileImage;
		if (chat?.profileChatCss) chat.profileChatCss.showProfileImage = showProfileImage;
		if (typeof chat?.save === "function") chat.save();
	};
</script>

{#if chat.isCurrentTab(tab)}
	<div class="tw-space-y-4 tw-font-sans tw-text-foreground">
		<Section title="AI챗의 이름을 작성해주세요!" required>
			<Input
				value={chat.title}
				maxlength="256"
				placeholder="AI챗의 이름을 작성해주세요!"
				on:change={onChangeTitle}
			/>
		</Section>

		<Section title="프로필 이미지를 적용해주세요!" required>
			<ImageUploadCard
				pickMode
				imageUrl={chat.getProfileImageContent()}
				showAi
				aiLabel="AI 이미지 생성"
				emptyText="클릭해서 이미지 자산에서 고르세요"
				on:pick={() => (profilePickerOpen = true)}
				on:remove={() => chat.changeProfileAsset(null, null)}
				on:ai={() => chat.handleAIImagePopup("profile")}
			/>
			{#if chat.chatVersion === "V3"}
				<div class="tw-mt-4 tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-border tw-bg-muted/40 tw-px-4 tw-py-3">
					<span class="tw-text-sm tw-text-foreground">채팅 화면에 프로필 이미지 표시</span>
					<Switch checked={showProfileImage} on:click={toggleProfileImage} />
				</div>
			{/if}
		</Section>

		<Section title="배경 이미지를 적용해주세요!">
			<ImageUploadCard
				pickMode
				imageUrl={chat.getBackImageContent()}
				showAi
				aiLabel="AI 배경이미지 생성"
				emptyText="클릭해서 이미지 자산에서 고르세요"
				on:pick={() => (backPickerOpen = true)}
				on:remove={() => chat.changeBackAsset(null, null)}
				on:ai={() => chat.handleAIImagePopup("background")}
			/>
			<div class="tw-mt-4 tw-rounded-lg tw-border tw-border-border tw-bg-muted/40 tw-p-4">
				<div class="tw-mb-3 tw-text-sm tw-font-semibold tw-text-foreground">배경 이미지 효과</div>
				<div class="tw-flex tw-flex-col tw-gap-3">
					<div class="tw-flex tw-items-center tw-justify-between">
						<span class="tw-text-sm tw-text-foreground">블러 효과</span>
						<Switch checked={chat.isBackImageBlur()} on:click={toggleBackImageBlur} />
					</div>
					<div class="tw-flex tw-items-center tw-justify-between">
						<span class="tw-text-sm tw-text-foreground">이미지 어둡게</span>
						<Switch checked={chat.isBackImageDarkly()} on:click={toggleBackImageDarkly} />
					</div>
				</div>
			</div>
		</Section>

		<Section title="AI챗 소개를 작성해주세요!" required>
			<Textarea
				rows={chat.getSubtitleRows()}
				placeholder="프로필에 노출되는 소개 문구 입니다. 어떤 AI챗인지 짧게 소개해보세요!"
				value={chat.subTitle}
				on:change={(e) => chat.change("subTitle", e.target.value)}
				on:input={(e) => handleTextareaNextbreak(e, "subTitle")}
			/>
		</Section>
	</div>

	<!-- 프로필/배경 이미지 자산 라이브러리 (로고와 동일한 공용 모달) -->
	<ImagePicker
		bind:open={profilePickerOpen}
		chatId={chat.chatId}
		contextFolder={chatAssetFolder(chat)}
		mode="single"
		currentAssetId={chat.profileAssetId}
		on:select={onProfilePick}
	/>
	<ImagePicker
		bind:open={backPickerOpen}
		chatId={chat.chatId}
		contextFolder={chatAssetFolder(chat)}
		mode="single"
		currentAssetId={chat.backAssetId}
		on:select={onBackPick}
	/>
{/if}
